import { Base } from "../../shared/components/dialogs/Base";
import { html } from "lit-html";

export class TitledDialog extends Base {
	constructor() {
		super();
		this.node.classList.add("dialog--titled");
		this.titleText = "";
		this.subtitleText = "";
		this.closeButtonText = "";
	}

	getTemplateHeaderLeft() {
		return html`
			<h1 class="ellipsis">${this.titleText}</h1>
			<h2 class="ellipsis">${this.subtitleText}</h2>
		`;
	}

	getTemplateHeaderRight() {
		return html`
			${super.getTemplateHeaderRight()}
			<button class="dialog__close-button inverted-button" @click=${this.hide}>
				<span class="close-icon fa--space-after"></span>
				<span>${this.closeButtonText}</span>
			</button>
		`;
	}
}
